import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "./footerNav.scss";
import CategoryPopup from "../CategoryPopup/CategoryPopup";
import {
  List,
  UtensilsCrossed,
  ReceiptIndianRupee,
  ConciergeBell,
  RotateCw,
} from "lucide-react";

const FooterNav = ({ onWaiterClick }) => {
  const navigate = useNavigate();
  const { restaurant, id, table } = useParams();
  const [openPopup, setOpenPopup] = useState(false);
  const [activeLabel, setActiveLabel] = useState("Home");
  const location = useLocation();

  const categoriesList = [
    { id: 1, category: "All Day Breakfast", count: 6 },
    { id: 2, category: "Chaat Specials", count: 22 },
    { id: 3, category: "Cakes", count: 1 },
    { id: 4, category: "Desserts", count: 1 },
    { id: 5, category: "Quick Bites", count: 17 },
    { id: 1, category: "All Day Breakfast", count: 6 },
    { id: 2, category: "Chaat Specials", count: 22 },
    { id: 3, category: "Cakes", count: 1 },
    { id: 4, category: "Desserts", count: 1 },
    { id: 5, category: "Quick Bites", count: 17 },
    { id: 1, category: "All Day Breakfast", count: 6 },
    { id: 2, category: "Chaat Specials", count: 22 },
    { id: 3, category: "Cakes", count: 1 },
    { id: 4, category: "Desserts", count: 1 },
    { id: 5, category: "Quick Bites", count: 17 },
    { id: 1, category: "All Day Breakfast", count: 6 },
    { id: 2, category: "Chaat Specials", count: 22 },
    { id: 3, category: "Cakes", count: 1 },
    { id: 4, category: "Desserts", count: 1 },
    { id: 5, category: "Quick Bites", count: 17 },
    { id: 1, category: "All Day Breakfast", count: 6 },
    { id: 2, category: "Chaat Specials", count: 22 },
    { id: 3, category: "Cakes", count: 1 },
    { id: 4, category: "Desserts", count: 1 },
    { id: 5, category: "Quick Bites", count: 17 },
    // ... Add all
  ];

  useEffect(() => {
    setActiveLabel(getActiveLabel());
  });

  const items = [
    {
      label: "Home",
      path: `/${restaurant}/${id}/${table}/menu`,
      svg: <List size={20} stroke="#312f2fcc" />,
    },
    {
      label: "Menu",
      path: null,
      svg: <UtensilsCrossed size={20} stroke="#312f2fcc" />,
    },
    {
      label: "Re-order",
      path: `/${restaurant}/${id}/${table}/reorder`,
      svg: <RotateCw size={20} className="sidebar-icon" />,
    },
    {
      label: "Pay Bill",
      path: `/${restaurant}/${id}/${table}/pay-bill`,
      svg: <ReceiptIndianRupee size={20} stroke="#312f2fcc" />,
    },
    {
      label: "Waiter Req",
      path: null,
      svg: <ConciergeBell size={20} stroke="#312f2fcc" />,
    },
  ];

  const footerAction = (label, path) => {
    setActiveLabel(label);
    label === "Waiter Req"
      ? onWaiterClick()
      : label === "Menu"
        ? setOpenPopup(true)
        : navigate(path);
  };

  const getActiveLabel = () => {
    if (location.pathname.includes("/menu")) return "Home";
    if (location.pathname.includes("/reorder")) return "Re-order";
    if (location.pathname.includes("/pay-bill")) return "Pay Bill";
    return null;
  };

  return (
    <footer className="footer-nav">
      {items.map(({ label, path, svg }) => (
        <div
          key={label}
          className={`footer-item ${activeLabel === label ? "active" : ""}`}
          onClick={() => {
            footerAction(label, path);
          }}
          role="button"
          tabIndex={0}
          onKeyPress={() => {
            label === "Waiter Req" ? onWaiterClick() : navigate(path);
          }}
        >
          {svg}
          <span style={styles.footerLabel}>{label}</span>
        </div>
      ))}

      <CategoryPopup
        open={openPopup}
        // categories={categoriesList}
        onClose={() => setOpenPopup(false)}
      />
    </footer>
  );
};

const styles = {
  footerLabel: {
    marginTop: 2,
    fontSize: 12,
    letterSpacing: 0.3,
  },
};

export default FooterNav;
